export default __webpack_public_path__ + "static/media/0168.85fc6839.jpg";